import {AbstractEvent} from "@/modules/base/events";
import {GroundSlot} from "@/modules/club-grounds/entity";

export class BeforeGroundSlotFinishedEvent extends AbstractEvent {
  constructor(
    public groundSlot: GroundSlot
  ) {
    super();
  }
}